/* eslint-disable react/no-multi-comp */
import { t } from 'i18next';

import { getSubStepValues } from '#models/general/steps';
import Checkbox from '#components/general/Checkbox';
import AdelphiFieldsRow from '#components/business/AdelphiFieldsRow';
import Input from '#components/general/Input';

import styles from './styles.module.scss';
import { HOUSE_KEEPING_FIELDS, WASH_SUBSTEPS_IDS } from './constants';

export const getHouseKeepingFields = ({ values, errors }) => {
  const getHouseKeepingValues = getSubStepValues(WASH_SUBSTEPS_IDS.HOUSE_KEEPING, values, errors);
  return [
    {
      key: 'causticCleanedRow',
      Component: AdelphiFieldsRow,
      fields: [
        {
          key: 'causticCleaned',
          innerFieldContainerClassName: styles.houseCleaningFirstColumn,
          Component: () => <div>{t(`${WASH_SUBSTEPS_IDS.HOUSE_KEEPING}:causticCleaned`)}</div>
        },
        {
          ...getHouseKeepingValues(HOUSE_KEEPING_FIELDS.CAUSTIC_CLEANED, false),
          Component: Checkbox,
          innerClassName: styles.innerCenterContainer,
          innerFieldContainerClassName: styles.houseCleaningSecondColumn
        }
      ]
    },
    {
      key: 'operatorsRow',
      Component: AdelphiFieldsRow,
      fields: [
        {
          key: 'operatorsTitle',
          innerFieldContainerClassName: styles.houseCleaningFirstColumn,
          Component: () => <div>{t(`${WASH_SUBSTEPS_IDS.HOUSE_KEEPING}:operator`)}</div>
        },
        {
          ...getHouseKeepingValues(HOUSE_KEEPING_FIELDS.OPERATOR, false),
          innerFieldContainerClassName: styles.houseCleaningSecondColumn,
          Component: Input
        }
      ]
    },
    {
      key: 'notesRow',
      Component: AdelphiFieldsRow,
      fields: [
        {
          key: 'notesTitle',
          innerFieldContainerClassName: styles.houseCleaningFirstColumn,
          Component: () => <div>{t(`${WASH_SUBSTEPS_IDS.HOUSE_KEEPING}:${HOUSE_KEEPING_FIELDS.NOTES}`)}</div>
        },
        {
          ...getHouseKeepingValues(HOUSE_KEEPING_FIELDS.NOTES, false),
          Component: Input,
          innerFieldContainerClassName: styles.houseCleaningSecondColumn
        }
      ]
    }
  ];
};
